module.exports = __webpack_public_path__ + "static/upload-f15f13d0e12c93eb112b6b8f7195be11.gif";